import script from "./YachtItem.vue?vue&type=script&setup=true&lang=js"
export * from "./YachtItem.vue?vue&type=script&setup=true&lang=js"

import "./YachtItem.vue?vue&type=style&index=0&id=47d3fed0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d3fed0"]])

export default __exports__